import { ActionType } from 'typesafe-actions';
import * as actions from './actions';
import { AxiosError } from 'axios';

export type SchedulesAction = ActionType<typeof actions>;

export interface SchedulesState {
  schedules: {
    data: Schedule[] | null;
    loading: boolean;
    error: AxiosError | null;
  };
  schedule: {
    data: Schedule | null;
    loading: boolean;
    error: AxiosError | null;
  };
}

export enum ScheduleListType {
  TREE_LIST = '0',
  CHART_LIST = '1',
  FORM_LIST = '2',
}

export interface ScheduleParams {
  enterpriseId: string;
  projectId?: string;
  scheduleId?: string;
  schedule?: any;
  nameList?: string[];
  index?: number;
  type?: ScheduleListType;
}

export interface ScheduleActionType {
  schedule: Schedule;
  parentList: Schedule[];
}

export interface Schedule {
  id: number;
  name: string;
  description?: string;
  complete: number;
  startDate: string;
  finishDate: string;
  gongjong: string;
  index: number;
  createdBy: any;
  project: any;
  parent: Schedule;
  children: Schedule[];
  depends: Schedule[];
  createdAt: string;
  updatedAt: string;
}
